import React from 'react'
const Header = () => {
	return (
		<div className="h-12 w-full space-x-2 z-[9999] bg-gray-200 border-b-2 border-gray-800 flex justify-between px-4 items-center fixed">
			<div className="flex flex-row space-x-2">
				<h1 className="text-center text-lg">Documentation</h1>
			</div>
		</div>
	);
};

export default Header;
